import type { IndexTrend } from '../lib/rates'

/** Small ▲/▼ chip for the Index cards. Down = cheaper = good for the shipper → green. */
export function TrendPill({ trend, className = '' }: { trend?: IndexTrend | null; className?: string }) {
  if (!trend || trend.pct_change === 0) return null
  const up = trend.pct_change > 0
  const cls = up ? 'text-up' : 'text-down'
  return (
    <span
      className={`mono inline-flex items-center gap-0.5 text-[11px] font-semibold ${cls} ${className}`}
      title={`Median 40HC ${up ? 'up' : 'down'} ${Math.abs(trend.pct_change)}% on a basket of ${trend.lanes} matched lanes since ${trend.days > 2 ? 'last week' : 'yesterday'}`}
    >
      {up ? '▲' : '▼'} {Math.abs(trend.pct_change).toFixed(1)}%
    </span>
  )
}
